import {PropsWithChildren} from 'react';
import * as styles from './cards.module.css';

const Cards = ({children}: PropsWithChildren) => (
    <div className={styles.root}>
        {children}
    </div>
);

export default Cards;
